enum UserEndpoints {
  GetHeader = "/api/auth/header",
  UserLogout = "/api/auth/logout",
  UserRegister = "/api/auth/register",
  UserLogin = "/api/auth/login",
  GetTable = "/api/table/get",
  GetAllTable = "/api/table/getAll",
  GetAllAccsTable = "/api/table/getAllAccs",
  GetOverall = "/api/table/getOverallStats",
}

export default UserEndpoints;
